import { SocketChannel } from '../core/channel'

class PublicChannel extends SocketChannel {
  constructor() {
    super()
  }
}

export const publicChannel = new PublicChannel()
